import qs from 'qs'

import { getRequest } from '../../utils'
import { Journal } from './types/journal'

export interface FetchJournalsResponseData {
  journals: Journal[]
}

export const fetchJournals = (organizationId: string): Promise<FetchJournalsResponseData> => {
  const queryParams = qs.stringify({
    organizationId,
    isArchived: false,
  })

  return getRequest(`/v2/journals?${queryParams}`)
}
